import PanelSection from "@pathwright/ux/src/components/augmentation/AugmentationPanelSection"
import { CoverPagePanelCategoriesSection } from "./CoverPagePanelCategories"
import { CoverPagePanelContributorsSection } from "./CoverPagePanelContributors"
import { CoverPagePanelOffersSection } from "./CoverPagePanelOffers"
import { CoverPagePanelPitchSection } from "./CoverPagePanelPitch"
import { CoverPagePanelSectionKey } from "../types"

export type CoverPagePanelSection = {
  sectionKey: CoverPagePanelSectionKey
  label: string
  heading: string
  triggerLabel: string
}

export function CoverPagePanelHome() {
  return (
    <PanelSection.Group>
      <CoverPagePanelPitchSection />
      <CoverPagePanelOffersSection />
      <CoverPagePanelContributorsSection />
      <CoverPagePanelCategoriesSection />
    </PanelSection.Group>
  )
}
